import { useState } from 'react';

export default () => {
  const [showForm, setShowForm] = useState(false);
  const [pickedData, setPickedData] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const closeForm = () => {
    setShowForm(false);
    setPickedData(null);
  };

  return {
    showForm,
    pickedData,
    loading,
    setShowForm,
    setPickedData,
    setLoading,
    closeForm,
  };
};
